import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import axios from 'axios';

interface ExternalLinkState {
  externalLink: string;
  externalLinkTitle: string;
  externalLinkDescription: string;
  loading: boolean;
  error: string | null;
}

const initialState: ExternalLinkState = {
  externalLink: '',
  externalLinkTitle: '',
  externalLinkDescription: '',
  loading: false,
  error: null,
};

export const fetchExternalLink = createAsyncThunk<
  ExternalLinkState,
  { couponToken: string | null },
  { rejectValue: string }
>('externalLink/fetchExternalLink', async (data, { rejectWithValue }) => {
  try {
    const response = await axios.post(
      '/survey/api/shopqr/external_link',
      !!data.couponToken ? data : null,
    );
    return response.data.data;
  } catch (err: any) {
    return rejectWithValue(
      err.response?.data?.message || 'Fetch external link failed',
    );
  }
});

const externalLinkSlice = createSlice({
  name: 'externalLink',
  initialState,
  reducers: {
    setExternalLink: (
      state,
      action: PayloadAction<Partial<ExternalLinkState>>,
    ) => {
      Object.assign(state, action.payload);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchExternalLink.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchExternalLink.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
        state.externalLink = action.payload?.externalLink;
        state.externalLinkTitle = action.payload?.externalLinkTitle;
        state.externalLinkDescription = action.payload?.externalLinkDescription;
      })
      .addCase(fetchExternalLink.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Unknown error';
      });
  },
});

export const { setExternalLink } = externalLinkSlice.actions;
export const externalLinkReducer = externalLinkSlice.reducer;
